import { useEffect } from 'react'
import { Button, Modal, Row } from 'react-bootstrap'
import './History.css'
interface Props {
    historial: any[]
    show: boolean
    onHide: () => void
    setErrorQuantities: (errorQuantities: number) => void
}

const LocalHistoryModalUsers = ({ historial, show, onHide, setErrorQuantities }: Props) => {
    useEffect(() => {
        setErrorQuantities(0)
    }, [])

    const reversedHistorial = [...historial].reverse();
    return (

        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Historial de Transacciones</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='fullhistorial'>
                    {reversedHistorial?.map((record, index) =>
                    (
                        <Row className={`d-flex justify-content-center ${record.success ? 'text-success' : 'text-danger'}`} key={index}>
                            <span title={record.info} className='text-center' style={{ fontSize: '12px' }}>

                                <span className='mx-1'>[{record.hour}]</span>
                                {record.type} usuario {record.user}: {record.success ? 'hecho' : 'fallo'}
                            </span>
                        </Row>

                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default LocalHistoryModalUsers
